module.exports = __webpack_public_path__ + "img/digisign.0cfdb78f.jpg";